document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('mObs-quick-add-overlay');
  const closeBtn = document.getElementById('mObs-modal-close');
  const infoContainer = document.getElementById('mObs-modal-info');
  const variantsContainer = document.getElementById('mObs-modal-variants');
  const addBtn = document.getElementById('mObs-modal-add-btn');

  let currentVariantId = null;

  // Carica le traduzioni da Liquid, con fallback di sicurezza
  const t = window.mObsTranslations || {
    viewdetails: "View Details",
    onesize: "One Size",
    size22: "Size",
    sizechart: "Size Chart",
    adding: "Adding...",
    adding2: "Add to bag"
  };

  // 1. Apri Modal e Carica Dati
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('.mObs-trigger-quick-add');
    if (!trigger) return;
    
    e.preventDefault();
    const handle = trigger.getAttribute('data-product-handle');
    
    // FIX GLITCH: Disabilita solo i click successivi, senza rompere l'SVG
    trigger.style.pointerEvents = 'none';

    try {
      const cleanHandle = handle ? handle.trim() : '';
      if (!cleanHandle) throw new Error("Handle vuoto");

      // FIX FONDAMENTALE: Usiamo la root dinamica di Shopify per supportare lingue e mercati
      const rootUrl = window.Shopify.routes ? window.Shopify.routes.root : '/';
      const urlToFetch = rootUrl + 'products/' + cleanHandle + '.js';

      const response = await fetch(urlToFetch);
      
      // Se Shopify dice ancora 404, l'errore passa al catch
      if (!response.ok) throw new Error(`Errore network: ${response.status}`);
      
      const product = await response.json();

      buildModalUI(product);
      openModal();

    } catch (err) {
      console.error("Impossibile caricare i dati JS del prodotto:", err);
      
      // SALVAGENTE: Se il popup non si può aprire, portiamo l'utente alla vera pagina del prodotto
      const rootUrl = window.Shopify.routes ? window.Shopify.routes.root : '/';
      window.location.href = rootUrl + 'products/' + (handle ? handle.trim() : '');
      
    } finally {
      // Riabilita il bottone
      trigger.style.pointerEvents = 'auto';
    }
  });

  // 2. Chiudi Modal
  const closeModal = () => {
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  };

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeModal();
  });

  const openModal = () => {
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  };

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
  }

  // 3. Costruisci Interfaccia
  function buildModalUI(product) {
    const priceFormatted = formatMoney(product.price);
    const imageUrl = product.featured_image ? product.featured_image : '';

    infoContainer.innerHTML = `
      <img src="${imageUrl}" alt="${product.title}" class="mObs-modal-img">
      <div class="mObs-modal-details">
        <div class="mObs-modal-sku">${product.variants[0].sku || ''}</div>
        <h3 class="mObs-modal-name">${product.title}</h3>
        <div class="mObs-modal-price">${priceFormatted}</div>
        <a href="${product.url}" class="mObs-modal-link">${t.viewdetails}</a>
      </div>
    `;

    variantsContainer.innerHTML = '';
    currentVariantId = null;
    addBtn.disabled = true;
    addBtn.innerHTML = t.adding2; // Reimposta il bottone alla lingua corretta

    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
      currentVariantId = product.variants[0].id;
      addBtn.disabled = !product.variants[0].available;
      variantsContainer.innerHTML = `<p>${t.onesize}</p>`;
    } else {
      let variantsHTML = `
        <div class="mObs-variant-title">
          <span>${t.size22}</span>
          <span class="mObs-size-guide">${t.sizechart}</span>
        </div>
        <div class="mObs-variants-grid">
      `;

      product.variants.forEach(variant => {
        const isSoldOut = !variant.available;
        const soldOutClass = isSoldOut ? 'is-soldout' : '';
        variantsHTML += `
          <button class="mObs-variant-btn ${soldOutClass}" data-id="${variant.id}">
            ${variant.title}
          </button>
        `;
      });

      variantsHTML += `</div>`;
      variantsContainer.innerHTML = variantsHTML;

      const variantBtns = variantsContainer.querySelectorAll('.mObs-variant-btn:not(.is-soldout)');
      variantBtns.forEach(btn => {
        btn.addEventListener('click', function() {
          variantBtns.forEach(b => b.classList.remove('is-active'));
          this.classList.add('is-active');
          currentVariantId = this.getAttribute('data-id');
          addBtn.disabled = false; 
        });
      });
    }
  }

  // 4. Aggiungi al Carrello e Aggiorna Drawer
  addBtn.addEventListener('click', async () => {
    if (!currentVariantId) return;

    addBtn.innerHTML = t.adding; // Testo "Aggiunta in corso..." tradotto
    addBtn.disabled = true;

    try {
      const formData = {
        'items': [{
          'id': currentVariantId,
          'quantity': 1
        }],
        'sections': 'cart-drawer,cart-icon-bubble',
        'sections_url': window.location.pathname
      };

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(formData)
      });
      
      const parsedState = await response.json();
      
      if (parsedState.status) {
        throw new Error(parsedState.description);
      }

      closeModal();
      
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.renderContents(parsedState);
      } else {
        window.location.href = '/cart';
      }

    } catch (error) {
      console.error('Errore aggiunta al carrello:', error);
      alert('Si è verificato un errore: ' + error.message);
    } finally {
      addBtn.innerHTML = t.adding2; // Torna al testo originale
      addBtn.disabled = false;
    }
  });
});